/* No chrome of its own: this sits inside the Muscle focus panel, which carries
   the heading and the border. */
.map {
  display: flex;
  flex-direction: column;
}

.views {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  flex: 1;
  max-width: 540px;
  margin: 0 auto;
  width: 100%;
}

.view {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
}

.modelWrap {
  position: relative;
  width: 100%;
}

/* Outline the body silhouette and subtly define muscle regions */
.modelWrap :global(.rbh polygon) {
  stroke: rgba(38, 33, 25, 0.18);
  stroke-width: 0.4;
}

.overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.overlay polygon {
  pointer-events: all;
  cursor: crosshair;
}

.tooltip {
  position: fixed;
  z-index: 9999;
  background: var(--canvas);
  border: 1px solid var(--border-md);
  border-radius: 8px;
  padding: 8px 12px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  box-shadow: 0 6px 20px rgba(38, 33, 25, 0.18);
}

.tooltipLabel {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--amber-strong);
}

.tooltipValue {
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  color: var(--soft);
}

.tooltipPrev {
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
  color: var(--muted);
  white-space: nowrap;
}

.up {
  color: var(--up);
}

.down {
  color: var(--down);
}
